import {$, bool, cnpj, cpfOrCnpj, datetime, InputType, Schema} from 'simpli-web-sdk'
import ConfigNovaSlaCalendarizacao from '@/model/resource/ConfigNovaSlaCalendarizacao'

export default (model: ConfigNovaSlaCalendarizacao): Schema => ({
  cnpjEmbarcador: {
    content: cpfOrCnpj(model.cnpjEmbarcador) || '',
  },
  cnpjTransportador: {
    content: cpfOrCnpj(model.cnpjTransportador) || '',
  },
  ufDestino: {
    content: model.ufDestino,
  },
  cidadeDestino: {
    content: model.cidadeDestino,
  },
  sla: {
    content: model.sla || '0',
  },
  segunda: {
    content: (model.calendarizacao && Number(model.calendarizacao.seg)) || '0',
  },
  terca: {
    content: (model.calendarizacao && Number(model.calendarizacao.ter)) || '0',
  },
  quarta: {
    content: (model.calendarizacao && Number(model.calendarizacao.qua)) || '0',
  },
  quinta: {
    content: (model.calendarizacao && Number(model.calendarizacao.qui)) || '0',
  },
  sexta: {
    content: (model.calendarizacao && Number(model.calendarizacao.sex)) || '0',
  },
  sabado: {
    content: (model.calendarizacao && Number(model.calendarizacao.sab)) || '0',
  },
  domingo: {
    content: (model.calendarizacao && Number(model.calendarizacao.dom)) || '0',
  },
})
